export const currencyFormat = (number) => {
    const formatter = new Intl.NumberFormat('en-US');
    return formatter.format(number);
};
export const getMinLoanAmount = (format = false) => {
    var _a;
    const val = ((_a = window === null || window === void 0 ? void 0 : window.loan_amount) === null || _a === void 0 ? void 0 : _a.min) || 500;
    return format ? currencyFormat(val) : val;
};
export const getMaxLoanAmount = (format = false) => {
    var _a;
    const val = ((_a = window === null || window === void 0 ? void 0 : window.loan_amount) === null || _a === void 0 ? void 0 : _a.max) || 2500;
    return format ? currencyFormat(val) : val;
};
